/**
 * AETERNA Design Tokens — 与 CSS Variables 同步的设计令牌
 *
 * @deprecated 优先使用 CSS Modules + CSS Variables (globals.css)
 *   CSS Modules: var(--color-clay), var(--space-4)
 *
 * ⚠️ 仅在以下场景使用 JS 常量：
 *   - SVG 填充色 (fill/stroke 属性不支持 CSS Variables)
 *   - framer-motion animate 属性中的颜色值
 *   - 动态拼接 gradient 字符串
 *
 * 所有其他场景请使用 CSS Modules 中的 var(--color-*)
 * 保持与 src/styles/globals.css 中的 CSS 变量同步
 */

// Colors (与 CSS --color-* 变量同步)
export const COLORS = {
  // Base
  bone: '#f7f5f0',
  stone: '#edeae3',
  sumi: '#1c1917',
  ash: '#78716c',

  // Accents
  clay: '#b87a62',
  celadon: '#8da39a',
  abyss: '#0c0a09',
  danger: '#9d5c55',

  // Alpha variants
  clayBg: 'rgba(184, 122, 98, 0.08)',
  celadonBg: 'rgba(141, 163, 154, 0.08)',
  border: 'rgba(28, 25, 23, 0.08)',
  ashAlpha: 'rgba(44, 42, 41, 0.6)',
} as const;

// Spacing (与 CSS --space-* 变量同步, 8px base)
export const SPACING = {
  1: '4px',
  2: '8px',
  3: '12px',
  4: '16px',
  5: '20px',
  6: '24px',
  8: '32px',
  10: '40px',
} as const;

// Typography (与 CSS --text-* 变量同步)
export const TYPOGRAPHY = {
  xs: '11px',
  sm: '12px',
  base: '14px',
  lg: '16px',
  xl: '20px',
  '2xl': '28px',
} as const;

// Font families
export const FONTS = {
  sans: '"Geist Variable", "Noto Sans SC", system-ui, sans-serif',
  serif: '"Noto Serif SC", "Source Han Serif SC", serif',
  mono: '"JetBrains Mono", "Fira Code", monospace',
} as const;

// Easing
export const EASING = {
  zen: 'cubic-bezier(0.2, 0.8, 0.2, 1)',
} as const;

export type ColorKey = keyof typeof COLORS;
export type SpacingKey = keyof typeof SPACING;
